import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    migrate: function () {
      return api.post('subscriptions/migrate', {})
    },

    o4dataset2020: function () {
      return api.post('surveillance/o4dataset2020', {})
    },

    all2019 () {
      return api.post(`surveillance/all`, { year: 2019 })
    },

    all2020 () {
      return api.post(`surveillance/all`, { year: 2020 })
    },

    all2021 () {
      return api.post(`surveillance/all`, { year: 2021 })
    },

    all2022 () {
      return api.post(`surveillance/all`, { year: 2022 })
    },

    all2023 () {
      return api.post(`surveillance/all`, { year: 2023 })
    },

    all2024 () {
      return api.post(`surveillance/all`, { year: 2024 })
    },

    all2025 () {
      return api.post(`surveillance/all`, { year: 2025 })
    },

    all2026 () {
      return api.post(`surveillance/all`, { year: 2026 })
    },

    surveys (request) {
      return api.post('survey/all', request)
    },

    remove (id) {
      return api.post('surveillance/remove', { id: id })
    },

    acceptConvention (request) {
      if (request.year === 2019) {
        return
      }

      return api.post('/surveillance/convention/accept', request)
    },

    refuseConvention (request) {
      if (request.year === 2019) {
        return
      }

      return api.post('/surveillance/convention/refuse', request)
    },

    getConventionHistory (request) {
      return api.post('/surveillance/convention/history', request)
    },

    downloadConvention (request) {
      if (request.year === 2019) {
        return
      }

      const url = request.role != null
        ? '/surveillance/convention/dlamend'
        : '/surveillance/convention/dlmain'
      return api.post(
        url,
        request,
        {
          responseType: 'arraybuffer'
        }
      )
    },

    uploadConvention (progress, request) {
      if (request.year === 2019) {
        return
      }

      const url = request.has('role') ? '/surveillance/convention/upamend'
        : '/surveillance/convention/upmain'
      return api.post(
        url,
        request,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progress
        }
      )
    },

    updateSubscription2019 (request) {
      return api.post(`subscriptions/update`, request)
    },

    updateSubscription (request) {
      return api.post('/surveillance/update/modules', request)
    },

    updateReferent (request) {
      return api.post(`referent/update`, request)
    },

    updateRegistrator (request) {
      return api.post(`registrator/update`, request)
    },

    updateEstablishment (request) {
      return api.post('/surveillance/update/establishment', request)
    },

    updateReaExplaurStatus (request) {
      return api.post('/surveillance/explaur/status', request)
    },

    setExplaurSwabStatus (request) {
      return api.post('/surveillance/explaur/swabst', request)
    },

    updateReaSinkStatus (request) {
      return api.post('/surveillance/sink/status', request)
    },

    updateWaterPoints (request) {
      return api.post('/surveillance/sink/waterpoints', request)
    },

    updateDataset (request) {
      return api.post('/surveillance/dataset/update', request)
    },

    updateDatasetSheets (request) {
      return api.post('/surveillance/dataset/sheets', request)
    },

    updateDatasetDenominators (request) {
      return api.post('/surveillance/dataset/denominators', request)
    },

    getDatasetSheets (request) {
      return api.post('/surveillance/dataset/get/sheets', request)
    },

    getDatasetDenominators (request) {
      return api.post('/surveillance/dataset/get/denom', request)
    }
  }
} else {
  module = {
    _all: [],

    all () {
      if (this._all.length === 0) {
        for (let i = 0; i !== 100; ++i) {
          this._all.push({
            id: i,
            establishment: { id: i, finess: i, name: `Test ${i}` },
            referent: [`${i}@${i}.cm`],
            convention: false,
            protocols: { b: true, rb: true, ri: false },
            badiUnits: [{ t: 0, ufs: [`Unit ${i}`] }, { t: 0, ufs: [`Unit ${i * 10}`] }],
            iadiUnits: []
          })
        }
      }
      return delay(1500)({
        data: {
          v: this._all.slice()
        }
      })
    },

    remove (request) {
      const id = request.i
      const pos = this._all.findIndex(e => {
        return e.id === id
      })

      let result = {}
      if (pos === -1) {
        result.err = 'id not found'
      } else {
        this._all.splice(pos, 1)
      }
      return delay(100)({ data: result })
    }
  }
}

export default module
